export default {
  debounce (fn, delay = 300) { // 默认300毫秒
    let timer
    return function (...args) {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        fn.apply(this, args) // this 指向vue
      }, delay)
    }
  },
  getProCurrentHref () {
    let _href = window.location.href
    let index = _href.indexOf('#')
    let newHref = _href.slice(0, index)
    if (newHref.indexOf('m=') > 0 || newHref.indexOf('module_name=') > 0 || newHref.indexOf('uniacid=') > 0) {
      newHref = newHref + '&s='
    } else {
      newHref = window.location.origin + '/index.php'
    }
    return newHref
  },
  pick (obj, arr) {
    return arr.reduce((acc, curr) => {
      if (curr in obj) {
        acc[curr] = obj[curr]
      }
      return acc
    }, {})
  }
}



// WEBPACK FOOTER //
// ./src/utils/public.js